var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoffmannGroupPictorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Misc/hoffmann-group-pictorial") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.1143579,13.596836 L9.25152845,16.2821646 L9.56284445,16.7330608 L9.56284445,20.4967093 L12.4162814,20.4967093 L12.4162814,15.4788093 L11.1143579,13.596836 Z M15.5777533,5.38167312 C15.5777533,4.34254831 14.7451905,3.5 13.7182039,3.5 C12.6912174,3.5 11.8586555,4.34254826 11.8586555,5.38167312 C11.8586555,6.42079919 12.6912183,7.26334854 13.7182039,7.26334854 C14.7451896,7.26334854 15.5777533,6.42079919 15.5777533,5.38167312 M18.9381246,15.6080651 L20.769642,16.3336268 L18.8453838,16.7976878 L19.4698077,18.6967164 L17.8386762,17.4753777 L16.6772017,19.152699 L16.6763081,17.1306988 L14.6936031,17.2749126 L16.2331893,16.0233558 L14.8719245,14.556373 L16.8432981,14.9869237 L17.148948,12.9556483 L18.0471142,14.802017 L19.8118381,13.8086706 L18.9381246,15.6080651 Z M22,16.1104226 C22,14.2455036 20.8403165,12.6534557 19.2056049,12.0173535 C18.7156707,11.8231726 18.1824957,11.7154601 17.6242725,11.7154601 C17.111972,11.7154601 16.6211414,11.8070149 16.1649021,11.9724737 C16.1422394,11.9805521 16.1195758,11.9883303 16.0972113,11.9967097 C16.0933348,11.9982048 16.0894592,11.9994016 16.08588,12.0008985 L13.7182039,8.57923523 L13.4328312,8.17531317 C13.0922909,7.74117248 12.5719392,7.46441175 11.981512,7.46441175 C11.3502306,7.46441175 10.7926047,7.78306032 10.3515733,8.42454761 C10.2463092,8.57923523 2,20.4967093 2,20.4967093 L5.47219358,20.4967093 L12.4162812,10.4609094 L14.3295062,13.2258272 C13.6579687,13.9971672 13.2503358,15.0057737 13.2503358,16.1104231 C13.2503358,18.5345502 15.2091835,20.5 17.6251678,20.5 C20.0414487,20.5 22,18.5345497 22,16.1104226 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Anfrage-optimierung-(Quantity-Field)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Misc/hoffmann-group-pictorial",
    transform: "translate(-2.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-area"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-Color",
    fill: "#FF7000",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Notification",
    transform: "translate(17.000000, 1.000000)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoffmannGroupPictorial);
export default __webpack_public_path__ + "static/media/hoffmann-group-pictorial.43c79564fc06d5ae25b7dc71dd5e9db6.svg";
export { ForwardRef as ReactComponent };